import { getChainedTokens, } from "@bracket/addressbook";
import { useEscrowStore, } from "@stores/escrow";
import { UnstakeRow, } from "./UnstakeRow";
import { getConnectionInfo, } from "@helpers";
import { Loader, } from "@bracket/react-loader";
import type { FunctionComponent, } from "react";

import "./Unstake.scss";



export declare type UnstakeProps = object;


export const Unstake: FunctionComponent<UnstakeProps> = ({

}) => {

	const classes = () => [ "unstake" ].join(" ");
	const { initialized, initializing } = useEscrowStore();
	const { chain, } = getConnectionInfo();

	if(!initialized || initializing) return <div className="loading"><Loader /></div>;
	
	return (
		<div className={classes()}>
			<table className="stake-table">
				<thead>
					<tr>
						<th className="stake">Stake</th>
						<th className="balance">Balance</th>
						<th className="amount">Amount</th>
						<th className="action">&nbsp;</th>
					</tr>
				</thead>
				<tbody>
				{
					getChainedTokens(chain as 1|42161, { stakable: true }).map(( token, idx) => {
						return <UnstakeRow key={token.symbol} token={token} />
					})
				}
				</tbody>
			</table>
		</div>
	);

}
